import React from 'react';
import { SettingsIcon, MailIcon } from 'lucide-react';
import { AccordionItem } from './Accordion';
import { OBJECTIONS, SUPPORT_EMAIL } from '../lib/constants';
// FAQ / objections handling + support footer with gear logo.
export function ObjectionsSection() {
  return <section className="px-5 py-8" data-id="element-93">
      <div className="mx-auto max-w-md" data-id="element-94">
        <h2 className="text-center font-[Montserrat] text-xl font-extrabold text-white" data-id="element-95">
          Resolvemos tus dudas
        </h2>

        <div className="mt-6 space-y-3" data-id="element-96">
          {OBJECTIONS.map((o, i) => <AccordionItem key={o.question} index={i} emoji="❓" title={o.question} description={o.answer} data-id="element-97" />)}
        </div>

        <footer className="mt-10 flex flex-col items-center gap-3 border-t border-[#c8a24a]/20 pt-8 text-center" data-id="element-98">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#c8a24a]/15 ring-1 ring-[#c8a24a]/40" data-id="element-99">
            <SettingsIcon className="h-6 w-6 text-[#e6c168]" aria-hidden="true" data-id="element-100" />
          </div>
          <p className="text-sm font-semibold text-white" data-id="element-101">Soporte</p>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="flex items-center gap-2 text-sm font-bold text-[#e6c168] underline-offset-2 hover:underline" data-id="element-102">
            <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-103" />
            {SUPPORT_EMAIL}
          </a>
          <p className="mt-2 max-w-xs text-[11px] leading-relaxed text-blue-200/70" data-id="element-104">
            Pack PER — Licencia de Navegación Sencilla. Producto digital de
            formación. Todos los derechos reservados.
          </p>
        </footer>
      </div>
    </section>;
}